module.exports = __webpack_public_path__ + "static/media/bg-green2.7911a510.svg";